import { WeightUnit } from "@redotech/cockroachdb-codegen/tables/product/weight-unit";
import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { splitWeight } from "@redotech/redo-fulfillment-outbound-labels-common/util";

function formatDisplayWeightGrams(
  displayWeightGrams: number,
  weightFormat: WeightFormat,
): string {
  if (weightFormat === WeightFormat.METRIC) {
    const [kg, g] = splitWeight(
      { unit: WeightUnit.G, value: displayWeightGrams },
      [WeightUnit.Kg, WeightUnit.G],
    );

    const metricParts = [];
    if (kg) {
      metricParts.push(`${kg} kg`);
    }

    if (g) {
      metricParts.push(`${g} g`);
    }

    return metricParts.join(", ");
  } else {
    const [lbs, oz] = splitWeight(
      { unit: WeightUnit.G, value: displayWeightGrams },
      [WeightUnit.Lb, WeightUnit.Oz],
    );

    const imperialParts = [];
    if (lbs === 1) {
      imperialParts.push(`${lbs} lb`);
    } else if (lbs > 1) {
      imperialParts.push(`${lbs} lbs`);
    }

    if (oz) {
      imperialParts.push(`${oz} oz`);
    }

    return imperialParts.join(", ");
  }
}

export function getOrderWeightCsvColumn(
  weightFormat: WeightFormat,
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: "Total weight",
    cell: (row: FulfillmentGroupData) =>
      formatDisplayWeightGrams(row.displayWeightGrams ?? 0, weightFormat),
  };
}
